import { render, staticRenderFns } from "./lossComparChart.vue?vue&type=template&id=535bab3e&"
import script from "./lossComparChart.vue?vue&type=script&lang=js&"
export * from "./lossComparChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535bab3e')) {
      api.createRecord('535bab3e', component.options)
    } else {
      api.reload('535bab3e', component.options)
    }
    module.hot.accept("./lossComparChart.vue?vue&type=template&id=535bab3e&", function () {
      api.rerender('535bab3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/attractManage/analyticStatistics/attractLossAnalysis/lossComparChart.vue"
export default component.exports